import React from 'react';
import { ManualIdField } from './ExternalLinkParts';

/** Typed-in IDs for when the picker does not list the event or session; session fields appear once their event has an ID. */
const ManualIdFields = ({ draft, onChange, saving, hasEvent }) => (
  <div className="session-external-links-manual">
    <ManualIdField
      id="manual-event-wp-id"
      label="Event WordPress ID"
      value={draft.eventWpId}
      onChange={(value) => onChange('eventWpId', value)}
      disabled={saving || !hasEvent}
    />
    <ManualIdField
      id="manual-event-faicon-id"
      label="Event Faicon ID"
      value={draft.eventFaiconId}
      onChange={(value) => onChange('eventFaiconId', value)}
      disabled={saving || !hasEvent}
    />
    {draft.eventWpId && (
      <ManualIdField
        id="session-wp-id"
        label="WordPress session ID"
        value={draft.wpSessionId}
        onChange={(value) => onChange('wpSessionId', value)}
        placeholder="e.g. 217046"
        disabled={saving}
      />
    )}
    {draft.eventFaiconId && (
      <ManualIdField
        id="session-faicon-id"
        label="Faicon session ID"
        value={draft.faiconSessionId}
        onChange={(value) => onChange('faiconSessionId', value)}
        placeholder="Faicon session UUID"
        disabled={saving}
      />
    )}
  </div>
);

export default ManualIdFields;
